module.exports = __webpack_public_path__ + "media/banners/paliwa-menu-91316adc.png";